import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { CargarReciboComponent } from './seguridad/cargar-recibo/cargar-recibo.component';
import { CropReciboModule } from './seguridad/cargar-recibo/crop-recibo/crop-recibo.module';
import { DirectivesModule } from './directives';
import { CropReciboComponent } from './seguridad/cargar-recibo/crop-recibo/crop-recibo.component';
import { GeocoderComponent } from './components';

@NgModule({
  declarations: [CargarReciboComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    IonicModule,
    RouterModule,
    CropReciboModule,
    DirectivesModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    IonicModule,
    RouterModule,
    CargarReciboComponent,
    CropReciboComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule { }
